import { colors, radius, shell, type } from '../theme';
import { BrandMark } from './BrandMark';

/**
 * What a screen shows while its first load is out (D31, after the ops
 * console's D30): the mark with its plus pulsing, beside a line naming what
 * is coming, in a pill held over the middle of the main column.
 *
 * It is fixed, not in flow, so the screen's own busy region keeps its shape
 * and nothing moves when the pill goes. The words are the status a screen
 * reader announces; the mark is decorative, so it is not read as "Veriplus".
 */
export function Waiting({ children }: { children: string }) {
  return (
    <div
      role="status"
      className="vp-appear"
      style={{
        position: 'fixed',
        top: '50%',
        left: `calc(${shell.sidebarWidth}px + (100vw - ${shell.sidebarWidth}px) / 2)`,
        transform: 'translate(-50%, -50%)',
        zIndex: 1,
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        padding: '10px 18px 10px 14px',
        background: colors.card,
        border: `1px solid ${colors.line}`,
        borderRadius: radius.pill,
        ...type.meta,
        fontWeight: 600,
        color: colors.navy,
        whiteSpace: 'nowrap',
      }}
    >
      <BrandMark size={20} decorative pulse />
      {children}
    </div>
  );
}
